import Player from '../Models/Player'
import URLs from '../Utils/URLUtils';

class LobbyConnection {

    constructor(player, lobby, {
        playersUpdatedCallback,
        publicIdUpdatedCallback,
        stateUpdateLobbyCallback,
        stateUpdateGameCallback,
        stateUpdateRevealCallback,
        sendDrawingCallback,
        cannotJoinCallback,
        disconnectedCallback
    } = {}) {
        this.playersUpdatedCallback = playersUpdatedCallback;
        this.publicIdUpdatedCallback = publicIdUpdatedCallback;
        this.stateUpdateLobbyCallback = stateUpdateLobbyCallback;
        this.stateUpdateGameCallback = stateUpdateGameCallback;
        this.stateUpdateRevealCallback = stateUpdateRevealCallback;
        this.sendDrawingCallback = sendDrawingCallback;
        this.cannotJoinCallback = cannotJoinCallback;
        this.disconnectedCallback = disconnectedCallback;

        const address = `${URLs.apiSocketURL}/connect?lobbyCode=${encodeURIComponent(lobby)}&playerId=${encodeURIComponent(player.id)}&displayName=${encodeURIComponent(player.displayName)}&avatar=${encodeURIComponent(player.avatar)}`;
        this.socket = new WebSocket(address);

        this.onmessage = this.onmessage.bind(this);
        this.onclose = this.onclose.bind(this);

        this.socket.onmessage = this.onmessage;
        this.socket.onerror = this.onerror;
        this.socket.onclose = this.onclose;
        this.socket.onopen = this.onopen;
        console.log('Web Socket enabled.');
    }

    parsePlayers(playerMap) {
        var result = {}
        for (var [id, player] of Object.entries(playerMap)) {
            result[id] = new Player(player.displayName, player.avatar, null, player.id, player.isAdmin);
        }
        return result;
    }

    onmessage(msg) {
        var messages = msg.data.split("\n")
        for (var message of messages) {
            var jsonResponse = JSON.parse(message);
            switch (jsonResponse.messageType) {
                case 'PLAYER_LIST_UPDATED':
                    this.playersUpdatedCallback({
                        connected: this.parsePlayers(jsonResponse.data.connected),
                        allPlayers: this.parsePlayers(jsonResponse.data.allPlayers),
                    });
                    break;
                case 'PUBLIC_ID':
                    this.publicIdUpdatedCallback(jsonResponse.data);
                    break;
                case 'STATE_UPDATE':
                    this.stateUpdate(jsonResponse.data);
                    break;
                case 'SEND_DRAWING':
                    this.sendDrawingCallback()
                    break;
                case 'SHARE':
                    if (this.shareCallback) {
                        this.shareCallback(jsonResponse.data)
                    }
                    break;
                case 'SHARE_ERR':
                    if (this.shareCallback) {
                        this.shareCallback("", jsonResponse.data)
                    }
                    break;
                case 'IS_CACHED':
                    if (this.isCachedCallback) {
                        this.isCachedCallback(jsonResponse.data)
                    }
                    break;
                case 'error':
                    this.handleError(jsonResponse.data);
                    break;
                default:
            }
        }
    }

    stateUpdate(data) {
        switch (data.stage) {
            case 'lobby':
                this.stateUpdateLobbyCallback(
                    {
                        connected: this.parsePlayers(data.connected),
                        allPlayers: this.parsePlayers(data.allPlayers),
                    },
                    {
                        roundLength: data.roundLength,
                        gameLength: data.gameLength,
                    },
                )
                break;
            case 'game':
                this.stateUpdateGameCallback(data.round, data.prompt, data.numRounds, data.roundLength, data.nextRound, data.drawing)
                break;
            case 'reveal':
                this.stateUpdateRevealCallback(data.prompts, data.drawings)
                break;
        }
    }

    handleError(err) {
        switch (err) {
            case 'CANNOT_JOIN_GAME':
                this.cannotJoinCallback();
                break;
            default:
                console.log("Unhandled error: " + err)
        }
    }

    startGame(settings) {
        this.send(JSON.stringify({
            messageType: "START_GAME",
            data: settings
        }))
    }

    sendDrawing(drawingData, round) {
        this.send(JSON.stringify({
            messageType: "DRAWING_UPDATE",
            data: Object.assign(drawingData, { round: round }),
        }))
    }

    appendPath(drawingData, round) {
        this.send(JSON.stringify({
            messageType: "APPEND_PATH",
            data: Object.assign(drawingData, { round: round }),
        }))
    }

    undoPen() {
        this.send(JSON.stringify({
            messageType: "UNDO_PEN",
        }))
    }

    undoMarker() {
        this.send(JSON.stringify({
            messageType: "UNDO_MARKER",
        }))
    }

    updateSettings(settings) {
        this.send(JSON.stringify({
            messageType: "UPDATE_SETTINGS",
            data: settings
        }))
    }

    isCached(drawingId, callback) {
        this.isCachedCallback = callback
        this.send(JSON.stringify({
            messageType: "IS_CACHED",
            data: {
                drawingId: drawingId
            }
        }))
    }

    share(drawingId, drawing, prompt, label, callback) {
        this.shareCallback = callback
        this.send(JSON.stringify({
            messageType: "SHARE",
            data: {
                drawingId: drawingId,
                imageData: drawing,
                prompt: prompt,
                label: label,
            }
        }))
    }

    send(data) {
        this.socket.send(data)
    }

    onerror(err) {
        console.log("°  error");
        console.log(err);
    }

    onclose(event) {
        console.log(event);
        if (!event.wasClean) {
            this.disconnectedCallback();
        }
    }

    onopen(event) {
        console.log("°  open socket");
    }

    close() {
        this.socket.close()
    }
}

export default LobbyConnection;